import {
  ReactElement,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';
import { createStrictOptionalContext } from 'helpers/context';

export interface ImportFromDocumentationContextType {
  isOpen: boolean;
  openImportDialog: () => void;
  closeImportDialog: () => void;
}

const {
  Provider: ImportFromDocumentationContextProvider,
  useRequiredContext: useImportFromDocumentationContext,
  useOptionalContext: useImportFromDocumentationContextOptional,
} = createStrictOptionalContext<ImportFromDocumentationContextType>(
  'useImportFromDocumentation',
  'ImportFromDocumentationProvider'
);

export function ImportFromDocumentationProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  const openImportDialog = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeImportDialog = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      isOpen,
      openImportDialog,
      closeImportDialog,
    }),
    [isOpen, openImportDialog, closeImportDialog]
  );

  return (
    <ImportFromDocumentationContextProvider value={value}>
      {children}
    </ImportFromDocumentationContextProvider>
  );
}

export function useImportFromDocumentation(): ImportFromDocumentationContextType {
  return useImportFromDocumentationContext();
}

export function useImportFromDocumentationOptional():
  | ImportFromDocumentationContextType
  | undefined {
  return useImportFromDocumentationContextOptional();
}
